export default {"src":"/_next/static/media/TTWO.2bbf44bd.svg","height":18,"width":18};